import React from 'react';

export default ({ children }) => (
  <div>
    {children}
  </div>
)


// WEBPACK FOOTER //
// ./src/components/ContentWrapper.js